function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: styles["icon"] || "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M551.936 256v-85.312h413.76L220.928 1024V85.312H55.424V0h331.008v597.312l248.32-256V256l-82.816 NaN",
  fill: "#242D42"
}), /*#__PURE__*/React.createElement("text", {
  x: "520",
  y: "1020",
  fontSize: "440",
  fill: "#242D42",
  fontFamily: "Arial, sans-serif",
  fontWeight: "bold"
}, "3"));